/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "__barrel_optimize__?names=useTheme!=!@mui/material";
import ReusableButton from "../../application/components/ReusableButton";
import { tokens } from "../../application/theme";
export default function LandingButton(props) {
    const { name, ...rest } = props;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return /*#__PURE__*/ _jsx(ReusableButton, {
        name: name,
        backgroundColor: colors.button.main,
        backgroundColorOnHover: colors.button.mainOnHower,
        color: "#FFF",
        ...rest
    });
}
